export const IGetLocalizationUseCaseType = Symbol('IGetLocalizationUseCase');
